import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css';
import {
  Carousel,
  CarouselItem,
  Row,
  Col,
  Card,
  Button,
} from 'element-ui'

Vue.use(Carousel)
Vue.use(Button)
Vue.use(CarouselItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Card)

